import { EMPTY_OBJECT } from '../../../constants/common'
import { REQUEST_PROFILE_TAB_RATING } from '../../../constants/request'
import { PROFILE_ROUTE_NAMES } from '../../../constants/route'
import {
  REQUEST_PROFILE_TAB_ACTIVITIES,
  REQUEST_PROFILE_TAB_ATTACHED_REQUESTS,
  REQUEST_PROFILE_TAB_CHATS,
  REQUEST_PROFILE_TAB_DOC_FLOWS,
  REQUEST_PROFILE_TAB_DOCUMENTS,
  REQUEST_PROFILE_TAB_EMAILS,
  REQUEST_PROFILE_TAB_INTERNAL_TASKS,
  REQUEST_PROFILE_TAB_POSTS,
  REQUEST_PROFILE_TAB_UPDATES,
} from '../RequestProfile.constants'
import { isRequestTerminalStatus } from '../RequestProfileHeaderStatusSelect'
import { RequestProfileTabActivities } from '../RequestProfileTabActivities'
import { RequestProfileTabAttachedRequests } from '../RequestProfileTabAttachedRequests'
import { RequestProfileTabChats } from '../RequestProfileTabChats'
import { RequestProfileTabDocFlows } from '../RequestProfileTabDocFlows'
import { RequestProfileTabDocuments } from '../RequestProfileTabDocuments'
import { RequestProfileTabEmails } from '../RequestProfileTabEmails'
import { RequestProfileTabInternalTasks } from '../RequestProfileTabInternalTasks'
import { RequestProfileTabPosts } from '../RequestProfileTabPosts'
import { RequestProfileTabRating } from '../RequestProfileTabRating'
import { RequestProfileTabUpdates } from '../RequestProfileTabUpdates'

import {
  REQUEST_PROFILE_TAB_PERMISSION_KEY,
  REQUEST_PROFILE_TAB_TITLE_KEY,
  REQUEST_PROFILE_TABS,
  REQUEST_PROFILE_TABS_WITH_COUNTERS,
} from './RequestProfileTabs.constants'

function getCanViewRequestProfileTab({ permissionKey, permissions }) {
  if (Array.isArray(permissionKey)) {
    return permissionKey.some(key =>
      getCanViewRequestProfileTab({ permissionKey: key, permissions })
    )
  }

  return Boolean(permissions[permissionKey])
}

export function isRequestProfileTabRating(tabId) {
  return tabId === REQUEST_PROFILE_TAB_RATING
}

export function getRequestProfileTabs({
  countersMap = EMPTY_OBJECT,
  isCountersLoading = false,
  requestData,
  t,
}) {
  const permissions = requestData?.permissions || EMPTY_OBJECT

  return REQUEST_PROFILE_TABS.reduce((acc, tabId) => {
    const permissionKey = REQUEST_PROFILE_TAB_PERMISSION_KEY[tabId]

    if (!getCanViewRequestProfileTab({ permissionKey, permissions })) {
      return acc
    }

    if (
      isRequestProfileTabRating(tabId) &&
      !isRequestTerminalStatus(requestData?.status?.id)
    ) {
      return acc
    }

    const tabCounters = countersMap[tabId] || EMPTY_OBJECT

    acc.push({
      count: tabCounters.total,
      id: tabId,
      isCountLoading:
        isCountersLoading && REQUEST_PROFILE_TABS_WITH_COUNTERS.includes(tabId),
      qaName: tabId,
      text: t(REQUEST_PROFILE_TAB_TITLE_KEY[tabId]),
      unreadCount: tabCounters.unread,
    })

    return acc
  }, [])
}

export function getRequestProfileTabUrl({ outboundUuid, requestId, tab }) {
  return outboundUuid
    ? PROFILE_ROUTE_NAMES.connectedRequestProfileNG({
        additionalParams: `/${tab}`,
        id: requestId,
        outboundUuid,
      })
    : PROFILE_ROUTE_NAMES.requestProfileNG({
        additionalParams: `/${tab}`,
        id: requestId,
      })
}

export function getActiveTabContent({ activeTabId, handleLoadCounters }) {
  switch (activeTabId) {
    case REQUEST_PROFILE_TAB_ACTIVITIES:
      return <RequestProfileTabActivities />
    case REQUEST_PROFILE_TAB_ATTACHED_REQUESTS:
      return <RequestProfileTabAttachedRequests />
    case REQUEST_PROFILE_TAB_CHATS:
      return <RequestProfileTabChats onLoadCounters={handleLoadCounters} />
    case REQUEST_PROFILE_TAB_DOC_FLOWS:
      return <RequestProfileTabDocFlows />
    case REQUEST_PROFILE_TAB_DOCUMENTS:
      return <RequestProfileTabDocuments onLoadCounters={handleLoadCounters} />
    case REQUEST_PROFILE_TAB_EMAILS:
      return <RequestProfileTabEmails onLoadCounters={handleLoadCounters} />
    case REQUEST_PROFILE_TAB_INTERNAL_TASKS:
      return (
        <RequestProfileTabInternalTasks onLoadCounters={handleLoadCounters} />
      )
    case REQUEST_PROFILE_TAB_POSTS:
      return <RequestProfileTabPosts />
    case REQUEST_PROFILE_TAB_RATING:
      return <RequestProfileTabRating />
    case REQUEST_PROFILE_TAB_UPDATES:
      return <RequestProfileTabUpdates />
    default:
      return null
  }
}
